import { Customer } from 'types';
import { ABTestCustomers } from './constants';
import routeHelpers from 'utils/route-helpers';

export function buildRedirectPath(
  path: string,
  customerId: string,
  locationId?: string,
) {
  return locationId
    ? path
        .replace(':customerId', customerId)
        .replace(':locationId', locationId)
        .split(locationId)
        .slice(0, 1)
        .concat([locationId])
        .join('')
    : path.replace(/:customerId\??/, customerId);
}

export function hasCustomerAssetMenu(customer: Customer) {
  return customer.country
    ? !['NL', 'BE', 'FR', 'DE'].includes(customer.country) // Country not in the list, menu is visible
    : true; // No country, menu is visible
}

export function hasCustomerEquipmentsAndDashboardMenus(customer: Customer) {
  return customer.country
    ? ['NL', 'BE', 'FR', 'DE'].includes(customer.country) || // Country in the list, menus are visible
        (customer.country === 'UK' && ABTestCustomers.includes(customer.id!)) // Or country is UK and customer ID is in the list, menus are visible
    : true; // No country, menus are visible
}

export function redirectToDefaultLocation(
  locationId: string,
  customerId: string,
  hasAssetsMenu: boolean,
  hasCustomerEquipmentsAndDashboardMenus: boolean,
) {
  if (hasAssetsMenu) {
    return routeHelpers.buildDashboardAssetsRoute(customerId, locationId);
  } else if (hasCustomerEquipmentsAndDashboardMenus) {
    return routeHelpers.buildMainDashboardRoute(customerId, locationId);
  } else {
    return routeHelpers.buildAdminCustomerManageRoute(undefined, customerId);
  }
}
